import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { KccLineChart } from "@/components/kcc/Charts";

export default function Water360() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/water/overview").then(({ data }) => setData(data)); }, []);
    const series = (data?.series || []).map((d) => ({
        date: d.date.slice(5, 10),
        raw: d.raw_water_m3 / 1000,
        recycled: d.recycled_m3 / 1000,
        process: d.process_m3 / 1000,
        discharge: d.discharge_m3 / 1000,
    }));
    return (
        <div className="space-y-6">
            <ModuleHeader kicker="Water360" title="Mine & Plant Water Balance" description="Raw water, recycled water, process consumption, potable and effluent discharge — daily balance with drought / flood scenario modelling." />
            <KpiGrid kpis={data?.kpis || []} accent="cobalt" cols={4} />
            <Panel title="60-day Water Flows (thousand m³)" accent="cobalt">
                <KccLineChart
                    data={series}
                    series={[
                        { key: "raw", label: "Raw", color: "#4f8bd9" },
                        { key: "recycled", label: "Recycled", color: "#22c55e" },
                        { key: "process", label: "Process", color: "#e88c4a" },
                        { key: "discharge", label: "Discharge", color: "#ef4444" },
                    ]}
                    height={320}
                />
            </Panel>
        </div>
    );
}
